/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {CartValidationResponseValidation} from './CartValidationResponseValidation';

/**
 * The CartValidationResponse model module.
 * @module model/CartValidationResponse
 * @version v1
 */
export class CartValidationResponse {
  /**
   * Constructs a new <code>CartValidationResponse</code>.
   * @alias module:model/CartValidationResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CartValidationResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CartValidationResponse} obj Optional instance to populate.
   * @return {module:model/CartValidationResponse} The populated <code>CartValidationResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CartValidationResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('validation'))
        obj.validation = CartValidationResponseValidation.constructFromObject(data['validation']);
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
CartValidationResponse.prototype.status = undefined;

/**
 * @member {module:model/CartValidationResponseValidation} validation
 */
CartValidationResponse.prototype.validation = undefined;

